import {findOrCreate} from "./find-or-create.js";
import {rootNamespace} from "./root.js";
import {defineResourceLoader} from "./lookup.js";

/**
 * @param {string} name
 * @param {import('./types').ResourceLoader} loader
 */
export function createFeature(name, loader) {
  const resource = findOrCreate(rootNamespace, [name]);

  defineResourceLoader(resource, loader);

  return resource;
}
